import { useSyncExternalStore } from 'react';

/**
 * This hook is a workaround for the following issue:
 * https://github.com/astoilkov/use-local-storage-state/issues/56
 * related to the `use-local-storage-state` library.
 * It subscribes to a no-op function and returns a boolean indicating
 * whether the component was rendered on the server or client side.
 */
export const useIsServerRendered = () => {
  const isServerRendered = useSyncExternalStore(
    () => {
      return () => {};
    },
    () => false, // client value
    () => true // server value
  );

  return isServerRendered;
};
